export default __webpack_public_path__ + "static/media/KarimAchengliBenmouais.dd1d4590.jpg";